import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { DataTablesModule } from 'angular-datatables';

import { HomeRoutingModule } from './home-routing.module';
import { HomeMainComponent } from './components/home-main/home-main.component';
import { HomeNavigateBarComponent } from './components/home-navigate-bar/home-navigate-bar.component';
import { HomeMainTableComponent } from './components/home-main-table/home-main-table.component';
import { HomeMainPagComponent } from './components/home-main-pag/home-main-pag.component';
import { HomeMainModalCustomerComponent } from './components/home-main-modal-customer/home-main-modal-customer.component';
import { BusAuctionFilterService } from './services/bus-auction-filter.service';
import { HomeMainModalDragComponent } from './components/home-main-modal-drag/home-main-modal-drag.component';
import { HomeMainModalRegionComponent } from './components/home-main-modal-region/home-main-modal-region.component';
import { HomeMainModalDetailComponent } from './components/home-main-modal-detail/home-main-modal-detail.component';
import { AuctionDetailService } from './services/home-auction-detail.service';
import { HomeMainModalManagerComponent } from './components/home-main-modal-manager/home-main-modal-manager.component';
import { TableModule } from 'primeng/table';
import { HomeMainModalMemberComponent } from './components/home-main-modal-member/home-main-modal-member.component';
import { HomeMainModalWinnerComponent } from './components/home-main-modal-winner/home-main-modal-winner.component';
import { HomeMainModalLogistComponent } from './components/home-main-modal-logist/home-main-modal-logist.component';
import { HomeMainModalDetailLogistComponent } from './components/home-main-modal-detail-logist/home-main-modal-detail-logist.component';
import { HomeMainModalDetailWinnerComponent } from './components/home-main-modal-detail-winner/home-main-modal-detail-winner.component';
import { HomeMainModalDetailManufacturerComponent } from './components/home-main-modal-detail-manufacturer/home-main-modal-detail-manufacturer.component';
import { HomeMainModalDetailMemberComponent } from './components/home-main-modal-detail-member/home-main-modal-detail-member.component';
import { HomeMainModalDetailBaseComponent } from './components/home-main-modal-detail-base/home-main-modal-detail-base.component';
import { NavbarInfoService } from './services/navbar-info.service';
import { TruncatePipe } from '../../pipe/truncate.pipe';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HomeReportComponent } from './components/home-report/home-report.component';
import { AuctionTypeChangeEmailDialogComponent } from "./components/home-main-modal-detail/auction-type-change-email-dialog";
import { ModalMailSenderComponent } from './components/home-main-modal-detail/modal-mail-sender/modal-mail-sender.component';
import { ModalMnnComponent } from './components/home-main-modal-detail/modal-mnn/modal-mnn.component';
import { ModalHistoryChangeComponent } from './components/home-main-modal-detail/modal-history-change/modal-history-change.component';
import { ModalSendAdjustmentComponent } from './components/home-main-modal-detail/modal-send-adjustment/modal-send-adjustment.component';
import { NullableNumberPipe } from '../../pipe/nullable.pipe';
import { AuctionFilterService } from './services/home-auction-filter.service';
import { OtherKpPageModule } from '../other-kp/other-kp-page.module';
import { NumericInputModule } from '../../directives/numeric-input.module';

@NgModule({
  imports: [
    CommonModule,
    HomeRoutingModule,
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    NgxSpinnerModule,
    OtherKpPageModule,
    NumericInputModule
  ],
  providers: [
    BusAuctionFilterService,
    AuctionDetailService,
    NavbarInfoService,
    AuctionFilterService,
    DecimalPipe
  ],
  declarations: [
    HomeMainComponent,
    HomeMainTableComponent,
    HomeMainPagComponent,
    HomeMainModalCustomerComponent,
    HomeMainModalDragComponent,
    HomeMainModalRegionComponent,
    HomeMainModalDetailComponent,
    HomeMainModalManagerComponent,
    HomeMainModalMemberComponent,
    HomeMainModalWinnerComponent,
    HomeMainModalLogistComponent,
    HomeMainModalDetailLogistComponent,
    HomeMainModalDetailWinnerComponent,
    HomeMainModalDetailManufacturerComponent,
    HomeMainModalDetailMemberComponent,
    HomeMainModalDetailBaseComponent,
    TruncatePipe,
    HomeReportComponent,
    AuctionTypeChangeEmailDialogComponent,
    ModalMailSenderComponent,
    ModalHistoryChangeComponent,
    ModalMnnComponent,
    ModalSendAdjustmentComponent,
    NullableNumberPipe
  ]
})
export class HomeModule { }



// WEBPACK FOOTER //
// ./src/app/modules/home/home.module.ts